import { Skeleton } from "@/components/ui/skeleton";
import SupabasePool from "@/lib/supabaseClient";
import { ProjectPostProps } from "@/type/ProjectTypes";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

export default function HeroWorkSummary() {
  const nav = useNavigate();

  const { data: projectOne, isLoading } = useQuery<ProjectPostProps[]>({
    queryKey: ["RECENT_PROJECT"],
    queryFn: async () => {
      const { data } = await SupabasePool.getInstance()
        .from("project_meta")
        .select(
          `
            *,
            project_meta_stack(
              project_stack(*)
            )
          `
        )
        .order("id", { ascending: false })
        .limit(6);
      return data as ProjectPostProps[];
    },
    staleTime: Infinity,
  });

  if (isLoading) {
    return (
      <div className=" flex flex-col gap-3 mt-1 ">
        <div className="flex gap-2 items-center mb-3">
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-10 h-4 rounded-full" />
        </div>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex flex-col gap-1">
            <Skeleton className="h-3.5 w-3/4" />
            <Skeleton className="h-3.5 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="h-full rounded-lg flex flex-col gap-1 md:max-w-none">
      <div className="text-sm opacity-50 mb-1 flex gap-2 items-center cursor-pointer pb-2">
        <span>Projects</span>
      </div>

      <div className="text-xs flex flex-col gap-3 mt-1 pl-4 border-l border-border">
        {projectOne?.slice(0, 3)?.map((p, idx) => (
          <a
            className="hover:underline cursor-pointer flex flex-col gap-1"
            key={`${p.id}:${idx}`}
            onClick={() => nav(`/work/${p.id}`)}
          >
            <p className="inline-flex items-center">
              <span className="line-clamp-1 text-sm md:text-xs max-w-[calc(100%-20px)]">
                {p.title}
              </span>
            </p>

            <p className="line-clamp-1 text-zinc-400 text-xs max-w-[70%] md:max-w-none">
              {p.description}
            </p>
          </a>
        ))}
      </div>
    </div>
  );
}
